/**
 * Reusable mixin for swapping station inputs
 * Can be used in both Train and Metro search components
 */
export const stationSwapMixin = {
  methods: {
    /**
     * Swaps the values of fromStation and toStation
     * Also clears any existing suggestions and errors
     */
    swapStations() {
      // Store the current values
      const tempFromStation = this.fromStation;
      const tempToStation = this.toStation;
      
      // Swap the values
      this.fromStation = tempToStation;
      this.toStation = tempFromStation;
      
      // Clear any existing suggestions
      if (this.fromSuggestions) {
        this.fromSuggestions = [];
      }
      if (this.toSuggestions) {
        this.toSuggestions = [];
      }
      
      // Hide suggestion dropdowns
      if (this.showFromSuggestions !== undefined) {
        this.showFromSuggestions = false;
      }
      if (this.showToSuggestions !== undefined) {
        this.showToSuggestions = false;
      }
      
      // Clear any existing errors
      if (this.error) {
        this.error = null;
      }

      // Emit swap event for any parent components that need to know
      this.$emit('stations-swapped', {
        from: this.fromStation,
        to: this.toStation
      });
    }
  }
};
